// extracted by mini-css-extract-plugin
export default {"outShowBaseInfo":"Detail_outShowBaseInfo__gN2xJ","col":"Detail_col__9c3ba","downloadBill":"Detail_downloadBill__D1hQ0"};